export function scrollTo(
  element: HTMLElement | null | undefined,
  to: 'top' | 'bottom' | number,
  options?: {
    defer?: boolean
    smooth?: boolean
    callbackDistance?: number
    callbackTimeout?: number
    callback?: () => void
  },
) {
  if (!element) return

  let lastScrollOffset: number | null = null
  let lastScrollTimestamp: number | null = null

  const callbackDistance = options?.callbackDistance ?? 5
  const callbackTimeout = options?.callbackTimeout ?? 1000

  const checkScrolled = (offset: number, getOffset: () => number) => {
    if (!options?.callback) return

    const currentOffset = getOffset()
    const now = Date.now()

    const complete = Math.abs(currentOffset - offset) <= callbackDistance

    const timeout =
      !complete &&
      lastScrollOffset !== null &&
      lastScrollTimestamp !== null &&
      Math.abs(lastScrollOffset - currentOffset) < callbackDistance &&
      now - lastScrollTimestamp >= callbackTimeout

    if (complete || timeout) {
      requestAnimationFrame(() => options?.callback?.())
      return
    }

    lastScrollOffset = currentOffset
    lastScrollTimestamp = now

    requestAnimationFrame(() => checkScrolled(offset, getOffset))
  }

  const scroll = () => {
    const offset = to === 'top' ? 0 : to === 'bottom' ? element.scrollHeight : to

    if (element.scrollIntoView) {
      element.scrollIntoView({
        behavior: options?.smooth === false ? 'auto' : 'smooth',
      })
    } else {
      element.scrollTop = 0
    }

    checkScrolled(offset, () => element.scrollTop)
  }

  options?.defer ? setTimeout(scroll) : scroll()
}

export function scrollToTop(options?: { defer?: boolean; smooth?: boolean; callback?: () => void }) {
  scrollTo(document.documentElement, 'top', options)
}
